import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default function completedviewdetails(component, id, status) {
  const Authorization = "bearer " + localStorage.getItem("token");
  const rider_id = localStorage.getItem("rider_id");
  component.props.completedViewDetails(null);
  fetch(`${API_URL}rest/V1/rider/getOrdersByJobId/${id}/${status}`, {
    method: "GET",
    headers: { "Content-Type": "application/json", Accept, Authorization },
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      if (data && data[0].status == "failure") {
        console.log("completedviewDetailsRider", data[0]);

        component.props.completedViewDetails("failure");
      } else {
        component.props.completedViewDetails(data[0]);
      }
    });
}



// WEBPACK FOOTER //
// ./src/utility/api/completeViewDetails.js